const staticFileBasePath = '/assets/static'
const s3Url = import.meta.env.VITE_APP_STORAGE_URL

const appConfig: Record<string, string | RegExp> = {
  APP_LOGO: `${staticFileBasePath}/images/appLogo.png`,
  PROFILE_SELECTION_ILLUSTRATION: `${staticFileBasePath}/images/select-profile.png`,
  EMPTY_RIGHT_PANE_LIGHT: `${staticFileBasePath}/images/empty-right-pane-light.svg`,
  EMPTY_RIGHT_PANE_DARK: `${staticFileBasePath}/images/empty-right-pane-dark.svg`,
  EMPTY_LIST_LIGHT: `${staticFileBasePath}/images/empty-list-light.svg`,
  EMPTY_LIST_DARK: `${staticFileBasePath}/images/empty-list-dark.svg`,
  LOGO_STORAGE_PATH: `${s3Url}/AllFiles/Uploads/Logos/`,
  EMAIL_REGEX: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  PASSWORD_STRENGTH_REGEX:
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^a-zA-Z\d\s]).*$/,
  LOGIN_REDIRECT_PATH: 'profileSelection'
}

export default appConfig
